import React from 'react';

import Button from 'components/Button';
import { ButtonColor, ButtonStyle } from 'components/Button/constants';
import { UseEvent } from 'modules/redux/states/events/hooks';

import styles from './styles.module.scss';

type DeclineEventProps = {
  approved: UseEvent['approved'];
  isLoading: UseEvent['isLoading'];
  isSending: UseEvent['isSending'];
  onDeclineEvent: UseEvent['handleApproveEvent'];
};

const DeclineEvent: React.FunctionComponent<DeclineEventProps> = ({
  approved,
  isLoading,
  isSending,
  onDeclineEvent,
}) => {
  return isLoading || onDeclineEvent ? (
    <Button
      className={styles['decline-event-button']}
      color={ButtonColor.RED}
      disabled={isLoading || isSending || typeof approved === 'boolean'}
      label={
        isLoading || approved === true
          ? ''
          : approved === false
          ? 'Declined'
          : 'Decline'
      }
      onClick={onDeclineEvent}
      style={ButtonStyle.PRIMARY}
    />
  ) : null;
};

export default React.memo(DeclineEvent);
